<template>
  <div class="d-flex align-items-center justify-content-center p-4">
    <b-card class="col-md-6 col-lg-6 col-xl-4 px-0">
      <form @submit.prevent autocomplete="off">
        <validation-observer ref="socialMediaAuthenticationRules">
          <div>
            <h3 class="text-xl font-weight-semibold">
              <span>{{ $t("common.please_insert_document") }}</span>
            </h3>
            <p class="linktext-subdued">
              <a href="#" v-b-tooltip.hover :title="$t('common.creation_garantee')" >
                {{ $t("common.why_we_need_that") }}
              </a>
            </p>

            <div class="mb-6" v-if="registrationAlert">
              <div class="alert alert-danger" role="alert">
                {{ registrationAlert }}
              </div>
            </div>

            <!-- @todo validar regra pois atualmente a consulta e feita apenas usando o cpf, por isso deixei fixo para nao pesquisar vazio-->
            <form-field-input
              name="curriculum.personal.cpf"
              v-model="curriculum.personal.cpf"
              mask="###.###.###-##"
              label-class="font-weight-semibold"
              inputmode="decimal"
              rules="required|cpf"
            />

            <!-- Cadastro via rede social não suporta estrangeiro: o vínculo da conta é feito somente por CPF -->

            <div class="d-flex flex-column gap-6 text-center">
              <b-button variant="primary" pill block @click="submit()">
                {{ $t("common.validate_informations") }}
              </b-button>
            </div>
          </div>
        </validation-observer>
      </form>
    </b-card>
  </div>
</template>

<script>
import companyMixin from "@state/company";
import { notify } from "@/plugins/notification";
import * as FormComponents from "@components/forms";
import { useCurriculum } from "@state/user/curriculum";
import { useChangeable } from "@state/behaviours/changeable";
import { useConfiguration } from "@state/user/configuration";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import * as _ from "lodash-es";
import { useDashboard } from "@state/user/dashboard";
import {
  continueAdmissionalOnboarding,
  isAdmissionalOnboardingActive,
} from "@/utils/admissionalOnboarding";

export default {
  mixins: [companyMixin],
  components: {
    ValidationObserver,
    ValidationProvider,
    ...FormComponents,
  },
  setup() {
    const curriculum = useCurriculum();
    const configuration = useConfiguration();
    const changeable = useChangeable();
    const dashboard = useDashboard();

    return {
      changeable,
      curriculum,
      configuration,
      dashboard,
    };
  },
  props: {
    social_media: String,
    hash: String,
  },
  data() {
    return {
      stateSubscribe: null,
      registrationAlert: null,
    };
  },
  created() {
    this.curriculum.resetState();

    this.stateSubscribe = this.changeable.$subscribe((mutation, state) => {
      const poll_changes = this.changeable.poolChanges("curriculum");
      this.changeCounter = poll_changes.counter;

      if (poll_changes.counter >= 1) {
        this.isSaving = true;
        this.changeable.localPersist("changeable-express-form");
        this.changeCounter = 0;
      }
    });
  },
  destroyed() {
    this.stateSubscribe();
  },
  methods: {
    submit() {
      this.registrationAlert = null;

      this.$refs.socialMediaAuthenticationRules.validate().then((success) => {
        this.$root.loading = true;
        if (success) {
          if (isAdmissionalOnboardingActive()) {
            this.curriculum.checkCpf({ cpf: this.curriculum.personal.cpf })
              .then((response) => {
                if (response.data.success) {
                  notify({title: "$t:errors.title.danger", message: "$t:errors.link_account.already-existent", variant: "danger"});
                  return;
                }

                this.$auth.fetch().then(() => {
                  if (_.isEmpty(this.$auth.user()?.cpf)) {
                    return this.curriculum.persist({
                      personal: {
                        cpf: this.curriculum.personal.cpf,
                      },
                    });
                  }
                }).then(() => {
                  continueAdmissionalOnboarding(this.$router, this.$auth, this.dashboard);
                });
              })
              .catch((error) => {
                notify({title: "$t:errors.title.danger", message: "$t:errors.registration.message", variant: "danger"});
              })
              .finally(() => {
                this.$root.loading = false;
              });
            return;
          }

          // VERIFICAR SE CPF JÁ EXISTE, E CASO POSITIVO, NEGAR ACESSO
          this.curriculum.checkRegistration({ cpf: this.curriculum.personal.cpf})
            .then((response) => {
              if (response.data.success) {
                const query = {
                  create_curriculum: "yes",
                  ...(!_.isEmpty(this.$route.query.active_flow)
                    ? { active_flow: this.$route.query.active_flow }
                    : {}),
                };

                this.$router.push({ name: "register2", query });
              } else {
                this.registrationAlert = this.$t("errors.link_account.already-existent");
              }
            })
            .catch((error) => {
              notify({title: "$t:errors.title.danger", message: "$t:errors.registration.message", variant: "danger"});
            })
            .finally(() => {
              this.$root.loading = false;
            });
        }
      })
      .finally(() => {
        this.$root.loading = false;
      })
    },
  },
};
</script>
